import React from 'react'
import './HealthITContent.scss'
import CallToActionBanner from '../../CallToActionBanner/CallToActionBanner'
import { Link } from '@reach/router'
import { FaFileAlt, FaSearch, FaRobot, FaLock, FaBullseye, FaCheckCircle, FaTrophy } from 'react-icons/fa'

export class HealthITContent extends React.Component {
  render() {
    return (
      <div className="health-it-content">
        <div className="split light subheader-block">
          <div className="text-wrap">
            Rackner delivers Health IT capabilities combining AI-powered document
            analysis, secure data processing, and regulatory compliance expertise - proven
            at the FDA's Center for Devices and Radiological Health and supporting
            the Defense Health Agency.
          </div>
        </div>

        <section className="padding-large">
          <h2>FDA AI Platform</h2>
          <div className="row">
            <div className="col-md-12">
              <div className="platform-highlight">
                <p>
                  For the FDA's Center for Devices and Radiological Health (CDRH),
                  Rackner built and deployed an AI mission platform supporting
                  AI-assisted document summarization, structured/unstructured data
                  extraction, and automated review workflows for medical device
                  submissions.
                </p>
              </div>
            </div>
          </div>
        </section>

        <div className="split pattern">
          <h2>Platform Capabilities</h2>
          <div className="row capabilities-grid">
            <div className="col-md-4">
              <div className="capability-box">
                <div className="icon"><FaFileAlt /></div>
                <div className="title">Document Analysis at Scale</div>
                <div className="description">
                  LLMs, OCR pipelines, and RAG to analyze PDFs and file metadata,
                  enabling reviewers to generate drafts and detect trends
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="capability-box">
                <div className="icon"><FaSearch /></div>
                <div className="title">Structured Data Extraction</div>
                <div className="description">
                  Automated extraction of key information from unstructured
                  medical device submission documents
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="capability-box">
                <div className="icon"><FaRobot /></div>
                <div className="title">AI-Assisted Workflows</div>
                <div className="description">
                  Automated review workflows that reduce manual effort while
                  maintaining human oversight and decision authority
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="capability-box">
                <div className="icon"><FaLock /></div>
                <div className="title">Secure Deployment</div>
                <div className="description">
                  AWS GovCloud with fully private VPCs, strict RBAC, and
                  organizational data isolation
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="capability-box">
                <div className="icon"><FaBullseye /></div>
                <div className="title">PIV/CAC Authentication</div>
                <div className="description">
                  Secure single sign-on with PIV/CAC integration for federal
                  workforce access control
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="capability-box">
                <div className="icon"><FaCheckCircle /></div>
                <div className="title">Classification & Trends</div>
                <div className="description">
                  Automated submission classification and trend detection to
                  improve regulatory efficiency
                </div>
              </div>
            </div>
          </div>
        </div>

        <section className="padding-large light">
          <h2>Responsible AI Implementation</h2>
          <div className="ai-principles">
            <div className="principle-item">
              <h3>Transparency</h3>
              <p>
                Clear visibility into how AI models process data and generate
                recommendations, with explainable outputs for reviewers.
              </p>
            </div>
            <div className="principle-item">
              <h3>Fairness</h3>
              <p>
                Unbiased processing of medical device submissions with consistent
                application of regulatory criteria across all cases.
              </p>
            </div>
            <div className="principle-item">
              <h3>Accountability</h3>
              <p>
                Human reviewers maintain final decision authority with full audit
                trails and comprehensive logging of all AI-assisted actions.
              </p>
            </div>
            <div className="principle-item">
              <h3>Security & Privacy</h3>
              <p>
                Protection of sensitive medical device information through
                encryption, access controls, and organizational data isolation.
              </p>
            </div>
          </div>
        </section>

        <div className="split">
          <h2>Defense Health Agency</h2>
          <div className="dha-section">
            <p>
              Rackner supports the Defense Health Agency (DHA), including the
              DHMS (Defense Health Management System). Our platform engineering
              and AI capabilities translate directly to Health IT use cases
              requiring secure data processing, compliance with healthcare-specific
              regulations, and integration with existing clinical and administrative
              workflows.
            </p>
            <div className="certifications">
              <div className="cert-item">
                <div className="cert-logo"><FaTrophy /></div>
                <div className="cert-text">
                  <strong>ISO 27001:2022 Certified</strong>
                  <p>
                    Demonstrates commitment to information security management - critical
                    for healthcare data protection
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="button-wrap">
            <Link to="/contact">
              <button className="btn-raised-light-blue-inverse big">
                Explore Health IT Solutions
              </button>
            </Link>
          </div>
        </div>

        <CallToActionBanner route={'insights'} linkText={'See Case Studies'} />
      </div>
    )
  }
}

export default HealthITContent
